import { render, staticRenderFns } from "./NewPost.vue?vue&type=template&id=bd15b492&scoped=true"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15b492",
  null
  
)

export default component.exports